<div class="setup-step">
    <div class="setup-step__body setup-step__body--split">
        <div class="setup-step__instructions">
            <p class="setup-step__intro">To set up an authenticator app:</p>
            <ol class="setup-step__list">
                <li>Open your authenticator app.</li>
                <li>Tap add (+), then choose "Scan a QR code".</li>
                <li>Scan the QR code, then enter the 6-digit code it shows.</li>
            </ol>
        </div>

        <div class="setup-step__enroll">
            <div class="setup-step__qr-skeleton" *ngIf="!qrCode" aria-hidden="true"><span></span></div>
            <div class="setup-step__qr" *ngIf="qrCode" [innerHTML]="qrCode"></div>
        </div>

        <div class="setup-step__secret-skeleton" *ngIf="!secretKey" aria-hidden="true"><span></span></div>
        <p class="setup-step__secret" *ngIf="secretKey">
            Can't scan? Enter this key manually: <strong>{{ secretKey }}</strong>
        </p>

        <app-otp-code-input
                class="setup-step__code"
                [disabled]="isSaving || isSuccess"
                [error]="hasError"
                [success]="isSuccess"
                (valueChange)="onCodeChange($event)"
                (completed)="verify($event)"></app-otp-code-input>
    </div>

    <div class="setup-step__footer">
        <button type="button"
                class="setup-step__back"
                [disabled]="isSaving || isSuccess"
                (click)="onBack()">{{ dismissLabel }}</button>
        <flex-spacer></flex-spacer>
        <button type="button"
                class="setup-step__verify"
                [class.setup-step__verify--success]="isSuccess"
                [disabled]="code.length < 6 || isSaving || isSuccess"
                (click)="verify(code)">
            <mat-spinner *ngIf="isSaving" class="setup-step__spinner" diameter="16"></mat-spinner>
            <span *ngIf="!isSaving && !isSuccess">Verify</span>
            <span *ngIf="isSaving">Verifying…</span>
            <span *ngIf="isSuccess">Verified</span>
        </button>
    </div>
</div>
